<template>
  <div>
    <drawer :app="app" />
    <v-container class="mt-1">
      <v-card raised>
        <v-card-title>
          <div v-html="$t('labels.ReviewAndSubmitTitle')"></div>
        </v-card-title>

        <v-card-text>
          <div style="color:black;" v-html="$t('labels.ReviewDesc')" />
          <div style="margin: 20px 0 5px 0;">
            <div v-if="app.Summary">
              <v-row dense>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-text style="color:black; padding:0;">
                      <v-list :expand="true">


                        <v-list-item v-if="app.InterView.DealPurposeDD!=3">
                          <v-list-item-icon>
                            <v-icon>fas fa-home fa-3x</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <div v-html="propertyDesc" />
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider v-if="app.InterView.DealPurposeDD!=3"/>

                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon>fas fa-user-friends fa-5x</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <div v-html="applicantDesc" />
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-card outlined class="mt-5">
                <v-card-text>
                  <v-textarea v-model="frm.comments" outlined :label="$t('labels.Comments')" />
                </v-card-text>
              </v-card>
              <v-card outlined class="mt-5">
                <v-card-title style="font-size: 16px;">{{ $t("labels.Consent") }}</v-card-title>
                <v-card-text>
                  <v-textarea rows="15" style="font-size:12px;" no-resize v-model="this.app.Summary.Consent" outlined readonly />
                   <div
                   v-for="a in app.Applicants"
                    v-bind:key="a.ApplicantID"                       
                    >                           
                  <v-checkbox
                    color="primary"
                    :key="a.ApplicantID"                    
                    :value="a.ApplicantID"                              
                    v-model="AcceptAll"
                    :label="$t(a.FirstName)+' '+ $t(a.LastName)+ ' - ' + $t('labels.AcceptTermAndConditions')"
                  />                 
                   </div>
                </v-card-text>
              </v-card>
            </div>

            <v-card-actions class="mb-5 mt-10">
              <v-spacer />
              <v-btn :disabled="AcceptAll.length != this.app.Applicants.length" @click="next" color="primary">{{ $t("labels.SubmitApplication") }}</v-btn>
            </v-card-actions>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
export default {
  components: {
    drawer
  },
  computed: {
    applicantDesc() {
      let temp = this.$t("labels.ReviewApplicant_Desc");

      if (this.app.Summary.TotalApplicantCount == 1) temp = this.$t("labels.ReviewApplicantSingle_Desc");

      if(this.app.Summary.TotalApplicantCount == 2) temp = this.$t("labels.Review2Applicant_Desc");
      
      temp = temp.replace("{0}", this.app.Summary.TotalApplicantCount);
      temp = temp.replace("{1}", this.app.Summary.MainApplicantName);
      temp = temp.replace("{2}", this.app.Summary.AllOtherApplicantNames);

      temp = temp.replace("{3}", this.app.Summary.strAnnualIncome);
      temp = temp.replace("{4}", this.app.Summary.PropertyCount);
      temp = temp.replace("{5}", this.app.Summary.strTotalAsset);

      return temp;
    },
    propertyDesc() {
      if (this.isPropertyFound) {
        let temp = this.$t("labels.ReviewDesc_PropertyFound");
        temp = temp.replace("{0}", this.app.InterView.strClosingDateMMM);
        temp = temp.replace("{1}", this.app.RequestedMortgage.SubjectProperty.Address.AddressLine1);
        temp = temp.replace("{2}", this.app.RequestedMortgage.strRequestedMortgageAmount);
        temp = temp.replace("{3}", this.app.InterView.strPropertyValue);
        temp = temp.replace("{4}", this.app.InterView.strDownPaymentAmount);

        return temp;
      }

      if (this.isRefinance) {
        let temp = this.$t("labels.ReviewDesc_Refinance");
        temp = temp.replace("{0}", this.app.RequestedMortgage.SubjectProperty.Address.AddressLine1);
        temp = temp.replace("{1}", this.app.RequestedMortgage.strRequestedMortgageAmount);
        temp = temp.replace("{2}", this.app.InterView.strClosingDateMMM);
        return temp;
      }
      if (this.isRenewal) {
        let temp = this.$t("labels.ReviewDesc_Renew");
        temp = temp.replace("{0}", this.app.RequestedMortgage.SubjectProperty.Address.AddressLine1);
        temp = temp.replace("{1}", this.app.RequestedMortgage.strRequestedMortgageAmount);
        temp = temp.replace("{2}", this.app.InterView.strClosingDateMMM);
        return temp;
      }
      if (this.isPropertyNotFound) {
        let temp = this.$t("labels.ReviewDesc_PropertyNotFound");
        temp = temp.replace("{0}", this.app.InterView.strDownPaymentAmount);
        return temp;
      }

      return null;
    },
    isOfferAccepted() {
      if (this.isPropertyFound && this.app.InterView.SearchStageDD == 1) return true;
      return false;
    },
    isPropertyFound() {
      if (this.app.InterView.DealPurposeDD == 0) {
        if (this.app.InterView.SearchStageDD >= 1 && this.app.InterView.SearchStageDD <= 3) {
          return true;
        }
      }
      return false;
    },
    isPropertyNotFound() {
      if (this.app.InterView.DealPurposeDD == 0) {
        if (this.app.InterView.SearchStageDD >= 4 && this.app.InterView.SearchStageDD <= 5) {
          return true;
        }
      }
      return false;
    },
    isRefinance() {
      if (this.app.InterView.DealPurposeDD == 2) return true;
      return false;
    },
    isRenewal() {
      if (this.app.InterView.DealPurposeDD == 4) return true;
      return false;
    }
  },
  data() {
    return {
      accept: false,
      AcceptAll: [],
      frm: {
        comments: null
      },
      Consent: null,
      loadFlag: false,
      app: model.appModel(),
      a: null,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false
    };
  },
  methods: {
    next() {    
      let postData = {
        Comments: this.frm.comments,
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };
      this.loadFlag = true;
      let url = "/api/mtgappsubmit";
      if(this.app.RequestReview == true){
        url = "/api/mtgappReviewsubmit"
      }
      dataSvc
        .getHttp()
        .post(url, postData)
        .then(res => {
          this.loadFlag = false;
          if(res.data.ReturnStatus.ReturnCode == 200){
            this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/success");
          }else{
            if(res.data.MissingDocs == true)
              this.$alert(this.$t("labels.Warning"), this.$t("errors.MissingRequiredDocuments"));
          }
          
        }).catch(err => {
          this.loadFlag = false;
          console.log(err);
           this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/success");
        });
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        LanguageID: localStorageSvc.getLanID()
      };

      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
            this.Consent = res.data.Summary.Consent;
            this.frm.comments = res.data.Summary.Comments;
          }
        });
    }
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  }
};
</script>
<style scoped>
.v-list-item__icon:first-child {
  margin-right: 16px !important;
}
</style>
